import { render, staticRenderFns } from "./Folders.vue?vue&type=template&id=7f01b8be&scoped=true"
import script from "./Folders.vue?vue&type=script&lang=js"
export * from "./Folders.vue?vue&type=script&lang=js"
import style0 from "./Folders.vue?vue&type=style&index=0&id=7f01b8be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f01b8be",
  null
  
)

export default component.exports